<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-${title}-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">{{title}} Map</span>
    </div>
    <b-collapse
      v-model="showCollapse"
      :id="`collapse-${title}-card`"
      >
      <div class="card-body">
        <LoadingSpinner v-if="!url" message ='Loading Property Map' size = '1x'>
        </LoadingSpinner>
        <iframe ref="Map" v-if="url && showCollapse"
          class="w-100"
          height="500"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          title="TerraTrac Property Map"
          :src="url"
        />
        <b-button size='sm' class="mr-2" @click="refreshIframe()">Refresh Map</b-button>
        <b-button size='sm' @click="openLinkInNewTab()">New Tab</b-button>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import CollapseControl from '@/mixins/CollapseControl';
import LoadingSpinner from '../LoadingSpinner.vue';

export default {
  name: 'MapCard',
  components: {
    LoadingSpinner,
  },
  mixins: [CollapseControl],
  data() {
    return {
      showCollapse: this.defaultOpened,
    };
  },
  props: {
    baseUrl: String,
    featureId: [Number, String],
    title: String,
    defaultOpened: Boolean,
  },
  computed: {
    url() {
      if (this.featureId) return this.baseUrl + this.featureId;
      return null;
    },
  },
  methods: {
    // resetting the iframe’s src attribute resets the map
    refreshIframe() {
      this.$refs.Map.src = this.$refs.Map.src;
    },
    openLinkInNewTab() {
      window.open(this.$refs.Map.src, '_blank');
    },
  },
};
</script>
